// static UI
import Box from 'UIKit/Box/Box'
import { HUSDUnLockBoosterBonus, LevelUpBonus, UserBonus, WageringConditionBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import SimpleActiveBonusContent from 'views/BonusCenter/components/BonusItem/BonusContent/ActiveBonusContent/SimpleActiveBonusContent'
import WageringBonusContent from './WageringBonusContent'

interface BonusItemProps {
  bonus: UserBonus
}

const ActiveBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  return (
    <Box>
      {(bonus instanceof LevelUpBonus || bonus instanceof HUSDUnLockBoosterBonus) && (
        <SimpleActiveBonusContent bonus={bonus} />
      )}
      {bonus instanceof WageringConditionBonus && <WageringBonusContent bonus={bonus} />}
    </Box>
  )
}

export default ActiveBonusContent
